export default __webpack_public_path__ + "static/media/ZoomCurier_logotype.24faee0e.png";